
import { Component, Mixins } from "vue-property-decorator";
import { Logger } from "..";

@Component({
})
export default class LogableMixin extends Mixins() {
  data(): any {
    return {
      logs: "",
      logger: new Logger(),
    };
  }
  logs: string;
  logger: Logger;

  pushLog(value: string): void {
    this.logger.push(value);
    this.logs = this.logger.toString();
  }
}
